export const selector = 'dbAAutofocus';

/* @ngInject */
export default function AutofocusDirective($parse, $timeout) {
    return {
        restrict: 'A',
        
        link: {
            post(scope, element, attrs) {
                const model = $parse(attrs[selector]);

                let watcher = scope.$watch(model, (shouldFocus) => {
                    watcher();
                    
                    if (shouldFocus) {
                        // TODO figure it out how to omit the magic number delay
                        $timeout(() => element[0].focus(), 500);
                    }
                });

                scope.$on('$destroy', watcher);
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/directive/autofocus/autofocus.directive.js